export default ":host ::ng-deep .iti__country-list {\n  /*position: fixed !important;*/\n}"